import { useAppStoreSelector } from "../../contexts/appStore/selectors";

export const MainClockRenderer = ({
  render,
}: {
  render: (date: Date) => React.ReactNode,
}) => {
  const date = useAppStoreSelector(store => store.mainClock);
  return <>{render(date)}</>;
};

/*
  Computes an elapsed time string and passes it to the render prop.
*/
export const MainClockElapsedRenderer = ({
  since,
  render,
}: {
  since: Date;
  render: (elapsed: string) => React.ReactNode,
}) => {
  return (
    <MainClockRenderer
      render={date => {
        const elapsedMs = date.getTime() - new Date(since).getTime();
        const totalSeconds = Math.floor(elapsedMs / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const pad = (num: number) => num.toString().padStart(2, '0');

        const string = hours > 0
          ? `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
          : `${pad(minutes)}:${pad(seconds)}`;

        return render(string);
      }}
    />
  );
};